import { render, staticRenderFns } from "./SchoolAdditionalInfoModal.vue?vue&type=template&id=d8d5d9ee&"
import script from "./SchoolAdditionalInfoModal.vue?vue&type=script&lang=js&"
export * from "./SchoolAdditionalInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports